import * as Yup from 'yup';
import { SarlaftDeclaration } from '../../../../../../shared/types/modules/sarlaft';

export const initialValues: SarlaftDeclaration = {
    lastYearTaxReturn: false,
};

export const validationSchema = Yup.object({
    lastYearTaxReturn: Yup.boolean(),
});
